import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HouseholdPage from './HouseholdPage';
import HouseholdMemberEditPage from './HouseholdMemberEditPage';

/** Pages under /casa/agregado. */
const HouseholdRoutes: React.FC = () => (
  <Routes>
    <Route index element={<HouseholdPage />} />
    <Route path="pessoa/nova" element={<HouseholdMemberEditPage />} />
    <Route path="pessoa/:memberId" element={<HouseholdMemberEditPage />} />
  </Routes>
);

export default HouseholdRoutes;
